// * Bootstrap libraries
import './_bootstrap';

// * Any other global site-wide JavaScript should be placed below.
// ── Password-suggestions tooltip ─────────────────────────────────────────────
// Drupal's password.js injects .password-suggestions as a sibling of the
// password field. We move it into a tooltip bubble shown on focus.
// ── Candidate profile sidebar scroll-spy ─────────────────────────────────────
function initProfileScrollSpy() {
  const navItems = document.querySelectorAll('.cp-sidebar__nav-item[href^="#"]');
  if (!navItems.length) return;

  const sections = [...navItems]
    .map(a => document.querySelector(a.getAttribute('href')))
    .filter(Boolean);

  if (!sections.length) return;

  // Match the scroll-margin-top set in CSS for these fieldsets.
  const NAVBAR_H = 90;

  const activate = (index) => {
    navItems.forEach((a, i) =>
      a.classList.toggle('cp-sidebar__nav-item--active', i === index)
    );
  };

  // ── Click: smooth scroll accounting for sticky navbar ────────────────────
  navItems.forEach((a, i) => {
    a.addEventListener('click', e => {
      e.preventDefault();
      const target = sections[i];
      if (!target) return;
      const top = target.getBoundingClientRect().top + window.scrollY - NAVBAR_H;
      window.scrollTo({ top, behavior: 'smooth' });
      activate(i);
    });
  });

  // ── Scroll spy: update active item while the user scrolls ────────────────
  // Strategy: whichever section's top is closest to (and above) the threshold
  // wins. Threshold = NAVBAR_H + a small look-ahead so the item activates
  // just before it reaches the top.
  const THRESHOLD = NAVBAR_H + 40;
  let ticking = false;

  const syncActive = () => {
    let active = 0;
    sections.forEach((sec, i) => {
      if (sec.getBoundingClientRect().top <= THRESHOLD) active = i;
    });
    activate(active);
  };

  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => { syncActive(); ticking = false; });
  }, { passive: true });

  syncActive(); // run once on page load
}

function initPasswordTooltip() {
  const passField = document.querySelector('.jobs-registration-form #edit-pass-pass1');
  const suggestions = document.querySelector('.password-suggestions');
  if (!passField || !suggestions) return;

  // Wrap the password input so we can position the tooltip relative to it
  const wrapper = passField.closest('.js-form-item');
  if (!wrapper) return;
  wrapper.style.position = 'relative';

  // Move suggestions into the wrapper so it can be positioned absolutely
  suggestions.classList.add('pw-tooltip');
  wrapper.appendChild(suggestions);

  let hideTimer;

  const show = () => {
    clearTimeout(hideTimer);
    // Only show if there is actual content (Drupal may leave it empty)
    if (suggestions.textContent.trim()) {
      suggestions.classList.add('pw-tooltip--visible');
    }
  };

  const hide = () => {
    hideTimer = setTimeout(() => {
      suggestions.classList.remove('pw-tooltip--visible');
    }, 150);
  };

  passField.addEventListener('focus', show);
  passField.addEventListener('blur', hide);
  suggestions.addEventListener('mouseenter', () => clearTimeout(hideTimer));
  suggestions.addEventListener('mouseleave', hide);

  // Re-evaluate visibility whenever Drupal updates the suggestions text
  const observer = new MutationObserver(() => {
    if (document.activeElement === passField) {
      suggestions.textContent.trim() ? show() : hide();
    }
  });
  observer.observe(suggestions, { childList: true, subtree: true, characterData: true });
}

// ── Experience: "Currently working here" hides End date ──────────────────────
// Uses event delegation so it works on initial load AND after paragraphs AJAX.

function expToggleEndDate(checkbox) {
  const subform =
    checkbox.closest('.paragraphs-subform') ||
    checkbox.closest('.draggable') ||
    checkbox.closest('tr');
  if (!subform) return;

  // Actual Drupal HTML for daterange (date-only storage):
  //   <h4>End date</h4>              ← standalone heading (previousElementSibling)
  //   <div id="...-end-value">       ← container for the input
  //     <div class="form-type-date">
  //       <input type="date" name="...end_value[date]">
  //     </div>
  //   </div>
  const endInput = subform.querySelector(
    '[name*="field_start_end_date"][name*="end_value"]'
  );
  if (!endInput) return;

  // Walk up to the named div container whose id ENDS with "-end-value".
  // Using $= (ends-with) so we don't accidentally match the input itself
  // (its id ends with "-end-value-date") or the .form-type-date wrapper.
  const endValueDiv = endInput.closest('[id$="-end-value"]') || endInput.parentElement?.parentElement;
  // The <h4>End date</h4> is the element immediately before the container.
  const endLabel = endValueDiv ? endValueDiv.previousElementSibling : null;

  // The daterange fieldset wraps both start and end date.
  const dateFieldset = endInput.closest('fieldset');

  if (checkbox.checked) {
    if (endValueDiv) endValueDiv.style.display = 'none';
    if (endLabel) endLabel.style.display = 'none';
    // Disable so the field is excluded from form submission and
    // bypasses client-side validation on the hidden empty input.
    endInput.disabled = true;
    endInput.value = '';
    // Clear any clientside_validation red-border state on the whole fieldset.
    if (dateFieldset) {
      dateFieldset.querySelectorAll('.error, .is-invalid').forEach(function (el) {
        el.classList.remove('error', 'is-invalid');
      });
    }
  } else {
    if (endValueDiv) endValueDiv.style.display = '';
    if (endLabel) endLabel.style.display = '';
    endInput.disabled = false;
  }
}

// Delegate change events — handles newly AJAX-added paragraphs automatically.
document.addEventListener('change', function (e) {
  if (e.target.matches('[name*="field_currently_working_here"]')) {
    expToggleEndDate(e.target);
  }
});

// Re-run after any Drupal AJAX completes (covers paragraphs add/remove).
document.addEventListener('ajaxSuccess', function () {
  document.querySelectorAll('[name*="field_currently_working_here"]').forEach(expToggleEndDate);
});

document.addEventListener('DOMContentLoaded', () => {
    initPasswordTooltip();
    initProfileScrollSpy();
    // Apply initial state for any pre-checked "Currently working here" boxes.
    document.querySelectorAll('[name*="field_currently_working_here"]').forEach(expToggleEndDate);
    // ── Mobile navigation panel ────────────────────────────────────
    const mobileToggle = document.getElementById('mobile-toggle');
    const mobileClose = document.getElementById('mobile-close');
    const navbarContent = document.getElementById('navbar-content');
    const DESKTOP = 992;

    if (mobileToggle && navbarContent) {
        // The dimmer is built here rather than in markup because the navbar is
        // duplicated across seven page templates. It used to be a pseudo-element
        // of the panel, which meant it could not be tapped to dismiss the menu.
        const overlay = document.createElement('button');
        overlay.type = 'button';
        overlay.className = 'navbar__overlay';
        overlay.setAttribute('aria-label', 'Close navigation');
        overlay.tabIndex = -1;
        // Appended inside .navbar, not <body>: the navbar is a stacking context
        // (sticky, z-index 1030) and the panel lives inside it, so an overlay on
        // <body> could never sit above the header strip without also covering
        // the panel. As a sibling of the panel it dims the header too.
        (document.querySelector('.navbar') || document.body).appendChild(overlay);

        const isOpen = () => navbarContent.classList.contains('is-active');

        const setState = (open) => {
            navbarContent.classList.toggle('is-active', open);
            mobileToggle.classList.toggle('is-active', open);
            overlay.classList.toggle('is-active', open);
            mobileToggle.setAttribute('aria-expanded', String(open));
            document.body.style.overflow = open ? 'hidden' : '';
        };

        const open = () => {
            setState(true);
            if (mobileClose) mobileClose.focus();
        };

        // restoreFocus is skipped when the menu closes because the user is
        // navigating away or the viewport grew, where moving focus to the
        // hamburger would be surprising.
        const close = (restoreFocus = true) => {
            setState(false);
            if (restoreFocus) mobileToggle.focus();
        };

        mobileToggle.addEventListener('click', () => (isOpen() ? close() : open()));
        if (mobileClose) mobileClose.addEventListener('click', () => close());
        overlay.addEventListener('click', () => close());

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && isOpen()) close();
        });

        // The same markup becomes the horizontal bar at lg, where an open state
        // means nothing and the scroll lock would leave the page stuck.
        window.addEventListener('resize', () => {
            if (window.innerWidth >= DESKTOP && isOpen()) close(false);
        });

        // Close on following a link, but let a submenu parent toggle instead.
        // Delegated so submenu links are covered too.
        navbarContent.addEventListener('click', (e) => {
            const link = e.target.closest('.navbar__link');
            if (!link || link.classList.contains('dropdown-toggle')) return;
            if (window.innerWidth < DESKTOP) close(false);
        });
    }

    // Saving a job is a server action now: the control is a link to
    // jobs_registration.save_job / unsave_job, which write the user's
    // field_saved_jobs. The handler that used to live here kept the list in
    // localStorage and called preventDefault(), so nothing was ever recorded
    // against the account and /user/N/saved-jobs stayed empty.
});

// Jobs search bar: don't post empty facet parameters.
//
// The location control posts the facet's own parameter so the choice lands in
// Active Filters. When nothing is chosen the browser would still send an empty
// f[0]=, which facets ignores but which leaves it sitting in the URL, so drop
// those controls on the way out.
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('form.jobs-search-bar, form.hero__search').forEach((form) => {
        form.addEventListener('submit', () => {
            form.querySelectorAll('[name^="f["]').forEach((input) => {
                if (input.value === '') {
                    input.disabled = true;
                }
            });
        });
    });
});
